// extracted by mini-css-extract-plugin
export default {"titleWrap":"Check_titleWrap__V0hKy","label":"Check_label__sAR1J","htmlContainer":"Check_htmlContainer__M6c6w"};